import { atom } from 'recoil';

export const ErrorState = atom({
    key: 'errorAlert',
    default: null,
});

export const ToastMessage = atom({
    key: 'Toast_Message',
    default: null,
});

export const LoadingState = atom({
    key: 'LoadingState',
    default: false,
});